/**
 * G2/K3 — kanal agaci. Degerler ds'lere `@KANAL` olarak BIREBIR gider; SQL `kanal_grup = @KANAL OR
 * kanal = @KANAL` ile esler. Metin `m_satis_saatlik_fis` kanal CASE'iyle ayni (SQL 136 guard'i kilitler).
 * 'Mağaza' hem grup hem kanal adidir; ayni deger, ayni sonuc.
 */
export const KANAL_AGACI: ReadonlyArray<{ grup: string; kanallar: readonly string[] }> = [
  { grup: 'Mağaza', kanallar: [] },
  { grup: 'Pazaryeri', kanallar: ['Trendyol', 'Yemeksepeti', 'Getir'] },
  { grup: 'Kurumsal', kanallar: ['Yemek Kartı', 'Diğer Kurumsal'] },
  // Tek alt kanalli grup: seciciye alt satir basilmaz (KanalSecici), ama URL degeri gecerlidir.
  { grup: 'Online', kanallar: ['Kendi Online'] },
];

const GECERLI = new Set(KANAL_AGACI.flatMap((g) => [g.grup, ...g.kanallar]));

export function kanalGecerliMi(k: string | null): k is string {
  return k !== null && GECERLI.has(k);
}

/** Tek kanali grubuna, grubu kendisine esler. Bilinmeyen -> undefined. */
export function kanalGrubu(k: string): string | undefined {
  return KANAL_AGACI.find((g) => g.grup === k || g.kanallar.includes(k))?.grup;
}

export function pazaryeriSeciliMi(k: string | null): boolean {
  return k !== null && kanalGrubu(k) === 'Pazaryeri';
}

/** Yemek karti ERP'ye urun kirilimi OLMADAN tek toplu kalem girer (spec §2.1). */
export function yemekKartiSeciliMi(k: string | null): boolean {
  return k === 'Yemek Kartı';
}

/** Sepet ortalamasi Magaza kanalindan (spec §3): Tumu ya da Magaza secimi. */
export function sepetHesaplanirMi(k: string | null): boolean {
  return k === null || k === 'Mağaza';
}
